import { ShareNotePayload, axiosClient } from '@nx-frontend/shared/api';
import { NoteServiceShareDto } from '@nx-frontend/shared/types';

interface ClientShareNoteParams extends Pick<ShareNotePayload, 'workspaceId' | 'options'> {
  noteId: string;
}

export async function clientShareNote(params: ClientShareNoteParams): Promise<NoteServiceShareDto> {
  const { data } = await axiosClient.post(
    `/v2/api/workspaces/${params.workspaceId}/notes/${params.noteId}/share`,
    params.options
  );
  return data;
}
